import classNames from 'classnames';
import React, { FC, Fragment } from 'react';
import { MomentProps } from 'react-moment';

import { useUserDateTimePreferences } from '@sbu/hooks.time';

import { Moment } from 'shared/components/internal/Moment';

import css from './Timestamp.module.scss';

type TimestampVariant = 'datetime' | 'date' | 'time';

interface TimestampProps extends Omit<MomentProps, 'format'> {
  timeClassName?: string;
  variant: TimestampVariant;
}

const Timestamp: FC<React.PropsWithChildren<TimestampProps>> = ({
  children,
  className,
  timeClassName,
  variant,
  ...rest
}) => {
  const { dateFormat, timeFormat } = useUserDateTimePreferences();

  return (
    <Fragment>
      {(variant === 'date' || variant === 'datetime') && (
        <Moment
          className={classNames(css.date, className)}
          format={dateFormat}
          {...rest}
        >
          {children}
        </Moment>
      )}
      {(variant === 'time' || variant === 'datetime') && (
        <Moment
          className={classNames(css.time, timeClassName)}
          format={timeFormat}
          {...rest}
        >
          {children}
        </Moment>
      )}
    </Fragment>
  );
};

export const Date: FC<
  React.PropsWithChildren<Omit<TimestampProps, 'variant' | 'timeClassName'>>
> = (props) => <Timestamp variant='date' {...props}></Timestamp>;

export const Time: FC<
  React.PropsWithChildren<Omit<TimestampProps, 'variant' | 'timeClassName'>>
> = ({ className, ...rest }) => (
  <Timestamp timeClassName={className} variant='time' {...rest}></Timestamp>
);

export const DateTime: FC<
  React.PropsWithChildren<Omit<TimestampProps, 'variant'>>
> = (props) => <Timestamp variant='datetime' {...props}></Timestamp>;
